
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Overview from "@/views/resources/documentation/base/carousel/Overview.vue";
import CustomExample from "@/views/resources/documentation/base/carousel/CustomExample.vue";

export default defineComponent({
  name: "carousel",
  components: {
    Overview,
    CustomExample
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Carousel");
    });
  }
});
